// Sentinel value for the "knowledge filter" (experience filter) used across
// the disease/finding/select pages to mean "no filter applied". Previously
// embedded as a raw literal `9` in equality checks across several files.
export const NO_KNOWLEDGE_FILTER = 9;

// The API's max_knowledge parameter for a filter value: null means no filter.
export const toMaxKnowledge = (knowledgeFilter) =>
  knowledgeFilter && knowledgeFilter !== NO_KNOWLEDGE_FILTER ? knowledgeFilter : null;
